import { render, staticRenderFns } from "./IconRemove.vue?vue&type=template&id=1cb7ecfc"
import script from "./IconRemove.vue?vue&type=script&lang=js"
export * from "./IconRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports